import { Permission } from 'interfaces/permissionOption';

type HasPermission = (permission: Permission) => boolean;

const studyPendingSlidesPermissions = [
  Permission.ApplyCaseManifest,
  Permission.UploadSlidesToAnyStudies,
  Permission.UploadSlidesToOwnStudies,
];

const nonSpecificStudyIds = new Set(['0', '-1', 'pending-slides']);

const isSpecificStudyId = (studyId?: string | number | null) =>
  Boolean(studyId) && !nonSpecificStudyIds.has(String(studyId));

export const canQueryPendingSlides = ({
  hasPermission,
  studyId,
}: {
  hasPermission: HasPermission;
  studyId?: string | number | null;
}) =>
  hasPermission(Permission.ViewPendingSlides) ||
  (isSpecificStudyId(studyId) && studyPendingSlidesPermissions.some(hasPermission));
